import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const authenticate = async (path, body) => {
    const { data } = await api.post(path, body);
    setToken(data.token);
    setUser(data.user);
    return { ...data.user, ref_bonus: data.ref_bonus || 0 };
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setToken(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login: (b) => authenticate("/auth/login", b), register: (b) => authenticate("/auth/register", b), logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
